import { AxiosError } from 'axios'

import { ErrorCode, ErrorResponse } from '@infura/packages.api'

export function isAxiosError(e: any): e is AxiosError<ErrorResponse> {
  return !!e.response
}

export function dbErrorToCopy(code: ErrorCode): string {
  switch (code) {
    case ErrorCode.INVALID_JSON_BODY:
      return 'Invalid payload.'

    case ErrorCode.METHOD_NOT_SUPPORTED:
      return 'Method not supported.'

    case ErrorCode.EMAIL_IN_USE:
      return 'Email is already in use.'

    case ErrorCode.MISSING_DATA:
      return 'Incomplete payload.'

    case ErrorCode.SERVER_ERROR:
      return 'Upstream server error.'

    case ErrorCode.NOT_FOUND:
      return 'No account was found with that email.'

    case ErrorCode.INVALID_DATA:
      return 'Invalid data.'

    // case Errors.NoRecaptcha:
    //   return 'No ReCaptcha token found, unable to verify registration.'

    // case Errors.Unauthorized:
    //   return 'We failed to authenticate you with those credentials.'

    // case Errors.Unverified:
    //   return 'Before you can login, you must verify your email address.'

    // case Errors.InvalidPassword:
    //   return 'Your password was incorrect.'

    // case Errors.RateLimited:
    //   return 'Too many attempts. Wait a few seconds and try again.'

    // case Errors.Unknown:
    //   return 'Sorry, something unexpected went wrong.'

    // case Errors.InvalidMFA:
    //   return 'Authenticator token is not valid'

    default:
      return 'Sorry, something unexpected went wrong.'
  }
}
